/**
 * Removes all spaces from a phone number string.
 * Example: "20 1234 567" -> "201234567"
 */
export const formatMsisdn = (phoneNumber: string, addPrefix: boolean = false): string => {
  let cleaned = phoneNumber.replace(/\s/g, '');
  if (addPrefix) {
    if (cleaned.startsWith('+36')) {
      // already has prefix
    } else if (cleaned.startsWith('36')) {
      cleaned = '+' + cleaned;
    } else {
      cleaned = '+36' + cleaned;
    }
  }
  return cleaned;
};

/**
 * Formats a phone number string to the format: +36 XX XXX XXXX
 * Example: "301234567" -> "+36 30 123 4567"
 * Example: "+36301234567" -> "+36 30 123 4567"
 * Example: "36301234567" -> "+36 30 123 4567"
 */
export const formatPhoneNumberWithSpaces = (phoneNumber: string, skipCountryCode: boolean = false): string => {
  // Remove any existing spaces or special characters
  let cleaned = phoneNumber.replace(/\s/g, '');

  // Remove +36 or 36 prefix if present
  if (cleaned.startsWith('+36')) {
    cleaned = cleaned.slice(3);
  } else if (cleaned.startsWith('36')) {
    cleaned = cleaned.slice(2);
  }

  // Check if the number has 9 digits (Hungarian mobile format without country code)
  if (cleaned.length === 9) {
    // Format: +36 XX XXX XXXX
    return `${skipCountryCode ? '' : '+36 '}${cleaned.slice(0, 2)} ${cleaned.slice(2, 5)} ${cleaned.slice(5)}`;
  }

  // Return original if format doesn't match
  return phoneNumber;
};
